<h1 align="center">Terms of Service</h1>

<p>
    <b>Last Updated:</b> November 15 2016
</p>

<p>
    Thank you for using PayBee.
</p>
<p>
    By using PayBee services you agree to terms laid out in this Terms of Service ("Terms of Service") along with privacy policy ("Privacy Policy") described at <a target="_blank" href="https://paybee.io/pp.html">paybee.io/pp.html</a>. If you do not agree with any of these terms please do not use PayBee.
</p>
<p>
    You agree to accept this Terms of Service when you sign up for, access, or use our products, services, content, features, technologies or functions offered on our website at PayBee.com and all related sites, applications, and services (collectively "Services").
</p>
<p>
    <b>Summary:</b>
</p>
<ul>
    <li>
        You must agree to this Terms of Service and Privacy Policy to use PayBee
    </li>
    <li>
        You agree not to use any PayBee proprietary information for purpose other than as permitted.
    </li>
    <li>
        We reserve the right, at our sole discretion, to terminate your account anytime for any activity deemed unacceptable.
    </li>
    <li>
        We might reverse any payment if it has been identified to be coming from a fraudulent activity. We may refuse to acknowledge or process the same.
    </li>
    <li>
        To the extent applicable, you agree to adhere to all agreements PayBee has with its partners including but not limited to Stripe, Plaid, and platforms like Apple App Store and Google Play App Store.
    </li>
    <li>
        For more details read the rest of this Terms of Service.
    </li>
    <li>
</ul>
<p>
    <b>Changes</b>
<p>
    We may amend this Terms of Service any time by posting a revised version on our website. The revised version will be effective as of the published effective date as the date of the Last Update.
</p>
<p>
    <b>Service Eligibility</b>
</p>
<p>
    You may use PayBee Services only if you are capable of forming a binding contract with PayBee and are not barred from using the Services under applicable law. By using the Services, you confirm that you are either a legal resident of the United States or a United States citizen. The Services may only be used for U.S. dollar transactions within the 50 states of the United States and the District of Columbia. The Services do not support payments in foreign currencies.
</p>
<p>
    <b>Privacy Policy</b>
</p>
<p>
    Please refer to our <a target="_blank" href="https://paybee.io/pp.html">Privacy Policy</a> for information on how we collect, use and disclose information from our users.
</p>
<p>
    <b>Signup to service</b>
</p>
<p>
    You create username and password by providing your email and phone number to PayBee. You can use this to log in to PayBee mobile app and or website located at paybee.io.
</p>
<p>
    <b>Registration and Passwords</b>
</p>
<p>
    When you register to use the Services, you will also be asked to choose a password. You are entirely responsible for maintaining the confidentiality of your password. You agree not to use the account, username, or password of another user at any time, or to disclose your password to any third party. You agree to notify us immediately at <u>contact&#64;paybee.io</u>. if you suspect any unauthorized use of your account or access to your password. You are solely responsible for any and all use of your account.
</p>
<p>
    <b>Dormant Accounts</b>
</p>
<p>
    If you leave any funds dormant in a PayBee Account and you do not give us instructions where to send them, we may be required by Law to deem the funds to be abandoned by you, and to deliver them to various government agencies. To the extent required by law, we will attempt to provide you Notice if we hold funds payable to you in an account beyond the applicable dormancy period for abandoned property. If we are unable to contact you, we will treat the funds in your PayBee Account to be abandoned, and will deliver them to the appropriate government authority (such as the Controller’s Office in California).
</p>
<p>
    <b>Accepted Payment methods</b>
</p>
<p>
    PayBee allows you to link your credit/debit cards and bank account for making donations to various payee organizations ("Payee"). PayBee is not money services business as defined by United States Department of Treasury. We only pass instruction for payment to our payment partners ("Payment Partners" or "Partners") on Payees and payers ("Payer", you, or an organization that has delegated you the authority to accept these terms) behalf. All payment information is maintained and charged by these Payment Partners and your rights with respect to the segment of the transaction processed by these Partners shall be governed by the terms of service and privacy policies of those Payment Partners. You can read about Payment Partners and their agreements by looking at the Payment Partner section of our Privacy Policy located at (//paybee.io/pp.html) or as published on the respective Payment Partner websites.
</p>
<p>
    We may change (add, remove, or replace) Payment Partners at any time. Accordingly, the applicable terms of service and privacy policies of the respective Payment Partners may also change from time to time. Your continued use of the Services constitutes your consent and agreement to such changes.
</p>
<p>
    <b>Your Authorization</b>
</p>
<p>
    By linking your bank account or credit card to PayBee you authorize to charge it for payments made to Payees using PayBee Services.
</p>
<p>
    <b>License</b>
</p>
<p>
    Subject to your compliance with this Terms of Service, PayBee grants you a limited non-exclusive, non-transferable, non-sub-licensable license to download and install a copy of the PayBee App on a mobile device that you own or control and to run, such copy of the App solely for your own personal, non-commercial purposes.
</p>
<p>
    <b>Additional Terms for App Store Apps</b>
</p>
<ul>
    <li>
        If you accessed or downloaded the App from the Apple Store, then you agree to use the App only: (i) on an Apple-branded product or device that runs iOS (Apple proprietary operating system software); and (ii) as permitted by the Usage Rules set forth in the Apple Store Terms of Service.
    </li>
    <li>
        If you accessed or downloaded the App from any app store or distribution platform (like the Apple Store, Google Play or the Amazon Appstore) (each, an App Provider), then you acknowledge and agree that:
    </li>
    <li>
        PayBee Terms of Service are concluded between you and PayBee, and not with App Provider, and that, as between PayBee and the App Provider, PayBee, is solely responsible for the App.
    </li>
    <li>
        App Provider has no obligation to furnish any maintenance and support Services with respect to the App.
    </li>
    <li>
        In the event of any failure of the App to conform to any applicable warranty, you may notify App Provider and App Provider will refund the purchase price for the App to you (if applicable) and, to the maximum extent permitted by applicable law, App Provider will have no other warranty obligation whatsoever with respect to the App.
    </li>
    <li>
        App Provider is not responsible for addressing any claims you have or any claims of any third party relating to the App or your possession and use of the App, including, but not limited to: (i) product liability claims; (ii) any claim that the App fails to conform to any applicable legal or regulatory requirement; and (iii) claims arising under consumer protection or similar legislation.
    </li>
    <li>
        In the event of any third-party claim that the App or your possession and use of the App infringes that third party’s intellectual property rights, purely due to your use of the App in accordance with this Terms of Service, PayBee will be solely responsible for the investigation, defense, settlement and discharge of any such intellectual property infringement claim to the extent covered by these Terms of Service and applicable law.
    </li>
    <li>
        Any third-party claim that the App or your possession and use of the App infringes that third party’s intellectual property rights due to your use of the App not in accordance with this Terms of Service, or in conjunction with your internal systems or any other third-party software or Apps in your systems, you will be, solely or to the extent required by law, responsible for the investigation, defense, settlement and discharge of any such claims. Provided at all times, you will provide PayBee with reasonable written notice of such claims and provide opportunity for participation in any settlement.
    </li>
    <li>
        App Provider and its subsidiaries are third-party beneficiaries of these Terms of Service as related to your license of the App, and that, upon your acceptance of the terms and conditions of these Terms of Service, App Provider will have the right (and will be deemed to have accepted the right) to enforce these terms as related to your license of the App against you as a third party beneficiary.
    </li>
    <li>
        You must also comply with all applicable third-party terms of service, if any, when using the App.
    </li>
    <li>
        You agree to comply with all U.S. and foreign export laws and regulations to ensure that neither the App nor any technical data related to it nor any direct product therein is exported or re-exported directly or indirectly in violation of, or used for any purposes prohibited by, such laws and regulations. By using the App you represent and warrant that: (i) you are not located in a country that is subject to a U.S. Government embargo, or that has been designated by the U.S. Government as a terrorist supporting country; and (ii) you are not listed on any U.S. Government list of prohibited or restricted parties.
    </li>
</ul>
<p>
    <b>Transaction History</b>
</p>
<p>
    You can access your transaction history and other information relating to your PayBee account ("PayBee Account") by logging into your PayBee Account and clicking on the "History" tab.  You agree to review your transactions through your PayBee Account with sufficient frequency to prevent possible fraud or illegal use.
</p>
<p>
    <b>Taxes and Other Expenses</b>
</p>
<p>
    You are solely responsible (i) for determining what, if any, taxes or fees ("Taxes") apply to your transactions; and (ii) assessing, collecting, reporting, or remitting Taxes to the appropriate tax authority. When you provide us your tax identification number, you agree that we may send electronic reports of tax documents (including Form 1099-K) to you. We are not obligated to nor will we determine the applicability of any Taxes, or calculate, collect, report, or remit any Taxes to any tax authority arising from any Transaction, but we may withhold any amounts that we deem appropriate to cover such Taxes if we cannot validate any tax identification number you provide us. We may send documents to you and tax authorities for transactions processed using the Services. Specifically, pursuant to the Internal Revenue Code, we may be required to file an informational return with the IRS reporting transactions and third-party network transactions with legal entities or persons that occur in a given calendar year. If you use our Services, you acknowledge that we will report the total amount of payments you receive each calendar year as required by the Internal Revenue Service.
</p>
<p>
    <b>PayBee Technology</b>
</p>
<p>
    <b>APIs and Dashboard</b>
</p>
<p>
    PayBee may provide access to its proprietary APIs that may be used to access the Services. You may use the APIs solely as described in the documentation or user guide that comes along with it to access and use the Service and process transactions on websites and other media. You may manage your PayBee Account and enable additional features through the PayBee dashboard ("Dashboard").
</p>
<p>
    You may use the APIs to utilize the Services on your website or inside your mobile applications. You may not use the API for any purpose, function, or feature not described in the documentation or otherwise communicated to you by us. We may update the APIs and their documentation from time to time, and may add or remove features and functionality.
</p>
<p>
    <b>Ownership of PayBee IP</b>
</p>
<p>
    PayBee or its licensors exclusively own all rights, title, and interest in the patents, copyrights (including rights in derivative works), moral rights, rights of publicity, trademarks or service marks, logos and designs, trade secrets, and other intellectual property embodied by, or contained in the APIs, Services, dashboard, and documentation (collectively, "PayBee IP") or any copies thereof. PayBee IP is protected by intellectual property laws and PayBee reserves all rights in PayBee IP not expressly granted to you in this Terms of Service. You acknowledge that the Services are protected by copyright, trademark, and other laws of the United States and foreign countries.  You agree not to remove, alter or obscure any copyright, trademark, service mark or other proprietary rights notices incorporated in or accompanying the Services.
</p>
<p>
    <b>Your Feedback </b>
</p>
<p>
    You may choose to or we may invite you to submit feedback, comments, or ideas about improvements to the Service, our APIs, our platform, or any other component of our products or services (" Feedback"). For Feedback PayBee can be reached at <u>contact&#64;paybee.io.</u>
</p>
<p>
    If you send Feedback to us, we will presume that your submission was voluntary, and delivered to us without any restrictions on our use of the Feedback and PayBee may use it for any purpose. You also agree that PayBee has no fiduciary or any other obligation to you in connection with the Feedback submitted to us, and that we are free to use your Feedback without any obligation, attribution or compensation to you.
</p>
<p>
    <b>Electronic Notices</b>
</p>
<p>
    You agree that PayBee can provide notices regarding the Service ("Notice") to you through our website, PayBee dashboard, application interface, by email, or physical addresses identified in your PayBee Account. Notices may include notifications about your PayBee Account, changes to the Services, or other information we are required to provide to you. You also agree that electronic delivery of Notices has the same legal effect as a physical copy delivered to you. We will consider a Notice to have been received by you within 24 hours of the time a Notice is either posted to our website, dashboard, application interface, or emailed to you.
</p>
<p>
    <b>SMS and Text Messages</b>
</p>
<p>
    You authorize PayBee to reach you or provide notices via text message to allow PayBee to verify your or your Representative’s control over your PayBee Account (such as through two-step verification), and to provide you with other critical information about your PayBee Account. Standard text or data charges may apply to such notices. Where offered, you may disable text message notifications by following instructions provided in the message. However, by disabling text messaging, you may be disabling important security procedures and controls intended to reduce the risk of fraud to you and your customers on your PayBee Account and may increase the risk of losses.
</p>
<p>
    <b>Service Limitations.</b>
</p>
<p>
    <b>Payment Reversals</b>
</p>
<p>
    Payments through PayBee Services may be reversed at a later time, for example, if such a payment is subject to a Chargeback, Reversal, Claim or otherwise invalidated. This means that for some of our users, payments received into their account may be returned to the Payer or otherwise removed from their account after they have received the donation, if the donation has been invalidated for some reason.
</p>
<p>
    <b>Prohibited Conduct, Activities, and Businesses</b>
</p>
<p>
    All interactions with our website or our Services must comply with this Terms of Service. The following conduct, activities, and businesses are expressly prohibited. This list is not exhaustive, and we reserve the right to revoke any user’s access to our Services, should any user’s behavior be deemed, in our sole discretion, to be in violation of these activities.  We may add to or update the prohibited conduct, activities, and businesses list at any time.
</p>
<p>
    <b>Conduct</b>
</p>
<ul>
    <li>
        Personal attacks on or abuse of users or anyone related to PayBee;
    </li>
    <li>
        Postings any malicious, unlawful or fraudulent materials;
    </li>
    <li>
        Posting of personal information (for yourself or anyone else);
    </li>
    <li>
        Phishing;
    </li>
    <li>
        Posting materials containing viruses or other malicious or destructive code;
    </li>
    <li>
        Posting of offensive content including profanity, obscenity, racist or pornographic material; or
    </li>
    <li>
        Posting of any materials that are defamatory or infringe any person's rights.
    </li>
</ul>

<p>
    <b>Activities</b>
</p>
<ul>
    <li>
        Providing purposely false, inaccurate or otherwise fraudulent information in connection with your account;
    </li>
    <li>
        Impersonating another person or otherwise misrepresent your affiliation with a person or entity, conducting fraud;
    </li>
    <li>
        Submitting information protected by copyright, trademark, and trade secret of other proprietary right collectively "intellectual property" or "IP" without the express permission of the owner of such IP;
    </li>
    <li>
        Accessing data, accounts, pages or information not authorized for your access purposefully, such as by logging into another’s account;
    </li>
    <li>
        Submitting content to PayBee Account that is in violation of applicable laws (including laws pertaining to solicitation and solicitation of minors, rights of privacy, rights of publicity, and intellectual property laws) related to the website or any third party’s rights;
    </li>
    <li>
        Using PayBee Service to advertise or solicit for commercial, political, religious purposed or otherwise, including unauthorized hyperlinking from other websites;
    </li>
    <li>
        Create work around or bypassing any technical limitations of the Service or enable functionality that is disabled or prohibited; or
    </li>
    <li>
        Reverse engineer the Service except as expressly permitted by law.
    </li>
</ul>
<p>
    <b>Businesses</b>
</p>
<p>
    Conduct any prohibited business activities ("Prohibited Business") as identified herein including but not limited to:
</p>
<ul>
    <li>
        Investment & credit services;
    </li>
    <li>
        Currency exchanges;
    </li>
    <li>
        Virtual currency;
    </li>
    <li>
        Transactions that involve product or services that infringes or facilitates infringement of 3rd party intellectual property rights;
    </li>
    <li>
        Transacting in counterfeit, illegal, or unauthorized goods, gambling, regulated products and services such as real estate, escrow services, or Marijuana, adult content and materials
    </li>
    <li>
        Business activities prohibited by our Payment Partners;
    </li>
    <li>
        Engaging in unfair, predatory, or deceptive practices; or
    </li>
    <li>
        Use of the Service in or for the benefit of a country, organization, entity, or person embargoed or blocked by any government, including those on sanctions lists identified by the United States Office of Foreign Asset Control (OFAC).
    </li>
</ul>
<p>
    <b>Security Controls </b>
</p>
<p>
    PayBee may provide or suggest security procedures and controls intended to reduce the risk to you of fraud. You agree to select and adopt the security controls that meet your business requirements. If you believe that the security controls we provide are insufficient, then you agree to separately implement additional controls that meet your requirements.
</p>
<p>
    <b>Your Security</b>
</p>
<p>
    You are solely responsible for the security of any data on your internal systems or you are otherwise authorized to access or share. You agree to comply with applicable laws and network rules when handling or maintaining customer data and PII.
</p>
<p>
    <b>Fraud, Unauthorized, or Illegal Use</b>
</p>
<p>
    We may refuse, condition, or suspend any transactions that we believe may violate this Terms of Service or other agreements you may have with PayBee. If we suspect or know that you are using or have used the Services for unauthorized, fraudulent, or illegal purposes, we may share any information related to such activity with the appropriate financial institution, regulatory authority, or law enforcement agency consistent with our legal obligations. This information may include information about you, your PayBee Account, your customers, and transactions made through your use of the Service. PayBee is not responsible if your mobile device or your Bank Account or Credit Card or information is lost, stolen, destroyed or used by someone without your permission. PayBee will have the right to suspend or terminate the Services if a fraudulently obtained mobile device, Bank Account, or Credit Card credentials are used to make payments via the PayBee App.
</p>
<p>
    <b>Relationships</b>
</p>
<p>
    Nothing in this Terms of Service establishes a partnership, joint venture, or other agency relationship between you and PayBee, or with any Payment Provider. Each party to this Terms of Service, and each Payment Provider, is an independent contractor. Unless a Payment Provider expressly agrees or requires, neither you nor we have the ability to bind a Payment Provider to any contract or obligation.
</p>
<p>
    <b>Compliance with Laws</b>
</p>
<p>
    You must use the Services in a lawful manner, and in compliance with all laws, rules, and regulations applicable to your use of the Service. This may include compliance with domestic and international laws related to use of financial services, consumer protection, unfair competition, privacy, false advertising, and any other laws relevant to your transactions.
</p>
<p>
    <b>Force Majeure</b>
</p>
<p>
    Neither party will be liable for any delays in processing or other nonperformance caused by telecommunications, utility, failures, or equipment failures; labor strife, riots, war, or terrorist attacks; nonperformance of our vendors or suppliers, fires or acts of nature; or any other event over which the respective party has no reasonable control. However, nothing in this section will affect or excuse any outstanding rights, liabilities or obligations to pay fees, reversals, returns, or means of settling disputes.
</p>
<p>
    <b>Termination</b>
</p>
<p>
    We may terminate your access to and use of the Services, at our sole discretion, at any time and without notice to you. We may also suspend your access to and use of the Services if you have violated the Terms of Service, pose an unacceptable fraud risk to PayBee, provide any false, incomplete, inaccurate or misleading information, or otherwise engage in any prohibited conduct, activities, or businesses stated herein. You may stop using the Services at any time by removing the App from your smartphone. If you delete the PayBee App from your smartphone, the PayBee App will no longer function. We may still retain details of your past transactions to the extent required to fulfill our obligations. The surviving provisions of this Terms of Service will remain in effect even after any termination of access.
</p>
<p>
    <b>Legal Process</b>
</p>
<p>
    PayBee may respond to and comply with any writ of attachment, lien, levy, subpoena, warrant, or other legal order ("legal process") that we believe to be valid. We or any Payment Provider may deliver or hold any funds or data as required in order to comply with such legal process, even if you are receiving funds or data on behalf of other parties. Where permitted by law, we will make reasonable efforts to provide you notice, by sending a copy to the email address we have on file for you. PayBee is not responsible for any losses, whether direct or indirect, that you may incur as a result of our response or compliance with any legal processes.
</p>
<p>
    <b>Representations and Warranties</b>
</p>
<p>
    By accepting the terms of this Terms of Service or using PayBee Service, you represent and warrant that: (a) you are eligible to register and use the Service and have the authority to execute and perform the required obligations; (b) any information you provide us about your business, products, or services is accurate and complete; (c) any charges in your PayBee Account represent a permitted transaction and the data within it accurately describe such transactions; (d) you will fulfill all of your obligations to your donors or customers and will resolve all disputes with them; (e) you will comply with all laws applicable to your business and use of the Services; (f) you will not use Services for household purposes or peer-to-peer money transmission, or (except in the normal course of business) intercompany transactions; and (g) you will not use the Service, directly or indirectly, for any purpose that violates the terms of this Terms of Service.
</p>
<p>
    <b>Warranty Disclaimers</b>
</p>
<p>
    THE SERVICES ARE PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND INCLUDING ANY EXPRESS, IMPLIED, OR STATUTORY WARRANTIES OF TITLE, MERCHANTABILITY, OR FITNESS FOR A PARTICULAR PURPOSE.
</p>
<p>
    YOU AFFIRM THAT PAYBEE DOES NOT CONTROL THE PRODUCTS OR SERVICES THAT YOU OFFER OR YOUR OBLIGATIONS TO DONORS WITH RESPECT TO USE OF FUNDS TRANSMITTED VIA PAYBEE APP. YOU UNDERSTAND THAT PAYBEE CANNOT GUARANTEE AND WE DISCLAIM ANY KNOWLEDGE OF YOUR DONOR’S AUTHORITY TO COMPLETE ANY TRANSACTION.
</p>
<p>
    PAYBEE DISCLAIMS AND DOES NOT GUARANTEE: (a) THE ACCURACY, RELIABILITY, OR CORRECTNESS OF ANY DATA PROVIDED THROUGH THE SERVICES; (b) THAT THE SERVICE WILL MEET YOUR SPECIFIC NEEDS; (c) THAT THE SERVICE WILL BE AVAILABLE AT ANY PARTICULAR TIME OR LOCATION, FUNCTION IN AN UNINTERRUPTED MANNER, AND BE SECURE; (d) ANY TRANSACTION PROCESSING TIMES OR PAYOUT SCHEDULES; (e) THAT PAYBEE WILL CORRECT ALL DEFECTS OR ERRORS IN THE SERVICE, APIS, DOCUMENTATION, OR DATA; OR (f) THAT THE SERVICE IS FREE OF VIRUSES OR OTHER HARMFUL CODE. USE OF DATA YOU ACCESS OR DOWNLOAD THROUGH THE SERVICE IS DONE AT YOUR OWN RISK YOU ARE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR PROPERTY, LOSS OF DATA, OR ANY OTHER LOSS THAT RESULTS FROM SUCH ACCESS OR DOWNLOAD.
</p>
<p>
    <b>Indemnification; Third Party Claims</b>
</p>
<p>
    You agree to defend PayBee and its officers, directors, employees, agents and service providers (collectively, "agents") against any claims, disputes, demands, liabilities, damages, losses, and costs and expenses, including, without limitation, reasonable legal and accounting fees, brought by a third party, and you agree to fully reimburse or indemnify PayBee for any such claims that result solely from: (i) your access or use of the Services; (ii) your breach or violation of any provision of this Terms of Service; (iii) any fees, fines, disputes, reversals, returns, or any other liability we incur as a result of your use of our Services; (iv) negligent or willful misconduct of your agents; or (v) contractual or other relationships between you and your customers/donors.
</p>
<p>
    <b>Limitation of Liability</b>
</p>
<p>
    PayBee will not be responsible or liable to you for any indirect, punitive, incidental, special, consequential, or exemplary damages resulting from your use or inability to use the Service, the unavailability of the Service, lost profits, personal injury, or property damage, or for any other damages arising out of, in connection with, or relating to your use of the Services, even if such damages are foreseeable, and whether or not you or PayBee have been advised of the possibility of such damages. PayBee is not liable, and deny responsibility for any damages, harm, or losses to you arising from or relating to hacking, tampering, or other unauthorized access or use of the Service, your PayBee Account, data, or your failure to use or implement anti-fraud measures or any data security measures.
</p>
<p>
    You agree to limit any liability not disclaimed and permitted by applicable law, to your direct and proven damages; and under no circumstances will any such liability exceed in the aggregate amount of fees paid by you to PayBee during the three-month period immediately preceding the event that gave rise to your claim for damages.
</p>
<p>
    These limitations will apply to claims based on, contracts, tort (including negligence), strict liability, or any other theory or basis.
</p>
<p>
    <b>Changes and Amendments</b>
</p>
<p>
    We may at any time amend, delete or add to this agreement, including the fees and other amounts which apply to your PayBee account (a "Change") by giving notice of such Change by posting a revised version of this Agreement through the PayBee website and app. In addition, if the revised version includes a substantial change, we will provide you with reasonable prior notice by posting 10 days notice on our website or by giving notice via email. We will make a Change unilaterally and you will be deemed to have accepted the Change after you have received notice Change with the Change taking effect once the 10 days is passed. The 10 days notice period will not apply where a Change is required by law or relates to the addition of a new service, extra functionality to the existing Service or any other change which neither reduces your rights nor increases your responsibilities. In such instances, the Change will be made without prior notice to you and shall be effective immediately.
</p>
<p>
    If you do not accept any Change, you must close your PayBee Account. If you do not object to a Change by closing your PayBee account within the 30-day notice period, you will be deemed to have accepted it. While you may close your Payee Account at any time and without charge, please note that you may still be liable to us after you terminate this agreement for any liabilities you may have incurred and are responsible for prior to closing your Payee Account.
</p>
<p>
    <b>Entire Terms of Service</b>
</p>
<p>
    This Terms of Service and all policies and procedures incorporated by reference constitute the entire agreement between you and Payee for provision and use of the Services. Except where expressly stated otherwise in a writing executed between you and Payee, this Terms of Service will prevail over any conflicting policy or agreement for the provision or use of the Services. This Terms of Service sets forth your exclusive remedies with respect to the Services. If any provision of this is held to be invalid or unenforceable under law, then it will be interpreted in a manner favorable to accomplish the objectives of such to the extent possible, and all remaining provisions will continue in full force and effect.
</p>
<p>
    <b>Dispute Resolution</b>
</p>
<p>
    In the event that there is a dispute or claim arising out of or relating to use of Services or related to or originating from this Terms of Service (excluding any dispute related to either party’s intellectual property) the parties agree to resolve such dispute or claim by arbitration in California before a single arbitrator applying the substantive law of the State of California, exclusive of its conflict or choice of law rules. This does not preclude the parties from seeking provisional remedies in aid of arbitration from a court of appropriate jurisdiction. The parties acknowledge that use of the Services evidences an interstate commerce transaction.  Notwithstanding anything to the contrary, the Federal Arbitration Act (9 U.S.C. §§ 1-16) will govern any arbitration.
</p>
<p>
    <b>Governing Law and Venue</b>
</p>
<p>
    These Terms of Service and any action related thereto will be governed by the laws of the State of California without regard to its conflict of laws provisions and in courts before the United States District Court for the Northern District of California.
</p>
<p>
    <b>Copyright Policy</b>
</p>
<p>
    Payee respects copyright law and expects its users to do the same. It is our policy to terminate in appropriate circumstances the accounts of users who repeatedly infringe the rights of copyright holders.
</p>
<p>
    The Digital Millennium Copyright Act of 1998 (the "DMCA") provides recourse for copyright owners who believe that material appearing on the Internet infringes their rights under U.S. copyright law. If you believe in good faith that any Payee content infringes your copyright, you may send us a notice requesting removed or denial of access to such content. Federal law requires that your notification include the following information: (i) a physical or electronic signature of a person authorized to act on behalf of the owner of copyright; (ii) identification of the copyrighted work claimed to have been infringed; (iii) identification of the material that is the subject of infringing activity and removal; (iv) information reasonably sufficient to contact the complaining party; and (v) a statement that the information in the notification is accurate, and under penalty of perjury, you are authorized to act on behalf of the owner of the copyright.
</p>
<p>
    All DMCA notifications must be sent to:
<p>
    PayBee Inc.<br>
    Attn: Legal Department<br>
    228 Elliott Dr, Menlo Park, CA - 94025<br>
</p>
<p>
    We provide the above contact information for purposes of the DMCA only and reserve the right to respond only to correspondence relevant to this purpose.
</p>
<p>
    <b>Payment Partners</b>
</p>
<p>
    To provide you with seamless experience we work with following Payment Partners, you can check our Payment Partner’s relevant policy documents by visiting respective urls.
</p>

<ul>
    <li>
        <b><u>Stripe:</u></b> We use stripe for card and ACH processing of payments. Check out Stripe’s legal documents at following url:
        <ul>
            <li>
                <a target="_blank" href="https://stripe.com/us/privacy">stripe.com/us/privacy</a>
            </li>
            <li>
                <a target="_blank" href="https://stripe.com/us/connect-account/legal">stripe.com/us/connect-account/legal</a>
            </li>
        </ul>
    </li>
    <li>
        <b><u>Plaid:</u></b> We use plaid in conjugation with stripe for instant verification of bank accounts, you can check Plaid legal documents at:
        <ul>
            <li>
                <a target="_blank" href="https://plaid.com/legal/">plaid.com/legal</a>
            </li>
        </ul>
    </li>
</ul>

<p>
    PayBee Inc.<br>
    228 Elliott Dr, Menlo Park, CA - 94025<br>
</p>

<p>
    <b>Copyright Notice:</b>
</p>
<p>
    Copyright © 2016 PayBee, Inc. All Rights Reserved
</p>
<img src="https://paybee.io/images/logo.png">